import { render } from "./SaveModal.vue?vue&type=template&id=4f2e4819&scoped=true"
import script from "./SaveModal.vue?vue&type=script&lang=js"
export * from "./SaveModal.vue?vue&type=script&lang=js"

import "./SaveModal.vue?vue&type=style&index=0&id=4f2e4819&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2e4819"]])

export default __exports__